<template>
  <v-form ref="form" v-model="validacion" lazy-validation
    ><!--ver para que el lazy validation xD -->
    <v-container grid-list-xl fluid>
      <v-flex>
        <v-card height="515">
          <v-container>
            <v-toolbar color="white" dark flat dense cad>
              <v-toolbar-title class="indigo--text"
                >Planificación de la visita</v-toolbar-title
              >
            </v-toolbar>
            <br />
            <v-layout>
              <v-flex xs12 md6>
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="390px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="fecha_coordinacion"
                      label="Fecha coordinación"
                      :error-messages="fechaErrors"
                      :box="isDisabledCap"
                      :readonly="isDisabledCap"
                      prepend-icon="event"
                      v-on="on"
                      @input="$v.fecha_coordinacion.$touch()"
                      @blur="
                        tipeView == 'modifica'
                          ? $v.fecha_coordinacion.$touch()
                          : null
                      "
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fecha_coordinacion"
                    @input="menu1 = false"
                    no-title
                    locale="es"
                    first-day-of-week="1"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout v-if="tipeView == 'crear' ? true : false">
              <v-flex md3>
                <v-text-field
                  v-model="curso"
                  label="RBD"
                  :box="isDisabled"
                  :readonly="isDisabled"
                  @input="$v.curso.$touch()"
                  @blur="tipeView == 'crear' ? $v.curso.$touch() : null"
                ></v-text-field>
              </v-flex>
              <v-flex md1>
                <v-btn
                  class="check"
                  flat
                  icon
                  color="blue"
                  title="Verificar RBD"
                  @click="loadDataRBD()"
                >
                  <v-icon>check_circle</v-icon>
                </v-btn>
              </v-flex>

              <v-flex md4>
                <v-select
                  v-model="nivel"
                  :items="nivelesSelect"
                  label="Nivel"
                  item-text="name"
                  item-value="code"
                  :box="isDisabledCap"
                  :readonly="isDisabledCap"
                  @input="$v.apellido1.$touch()"
                  @blur="tipeView == 'crear' ? $v.apellido1.$touch() : null"
                ></v-select>
              </v-flex>
              <v-flex md4>
                <v-text-field
                  v-model="nombreCentro"
                  label="Nombre Centro"
                  :box="isDisabledCap"
                  :readonly="isDisabledCap"
                  @input="$v.apellido1.$touch()"
                  @blur="tipeView == 'crear' ? $v.apellido1.$touch() : null"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout v-if="tipeView == 'crear' ? true : false">
              <v-flex md3>
                <v-text-field
                  v-model="rutExaminador"
                  label="Rut Examinador"
                  counter="10"
                  maxlength="10"
                  :box="isDisabledCap"
                  :readonly="isDisabledCap"
                  @input="dvRut()"
                  @focusout="checkRut"
                  @blur="tipeView == 'crear' ? $v.rut.$touch() : null"
                ></v-text-field>
              </v-flex>
              <v-flex md1>
                <v-btn
                  class="check"
                  flat
                  icon
                  color="blue"
                  title="Verificar Rut"
                  @click="loadDataExaminadores()"
                >
                  <v-icon>check_circle</v-icon>
                </v-btn>
              </v-flex>
              <v-flex md4>
                <v-text-field
                  v-model="nombreExaminador"
                  label="Nombre Examinador"
                  :box="isDisabledCap"
                  :readonly="isDisabledCap"
                  @input="$v.apellido1.$touch()"
                  @blur="tipeView == 'crear' ? $v.apellido1.$touch() : null"
                ></v-text-field>
              </v-flex>
              <v-flex md4>
                <v-text-field
                  v-model="apellidoExaminador"
                  label="Apellido Examinador"
                  :box="isDisabledCap"
                  :readonly="isDisabledCap"
                  @input="$v.apellido1.$touch()"
                  @blur="tipeView == 'crear' ? $v.apellido1.$touch() : null"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout v-if="tipeView == 'crear' ? true : false">
              <v-flex md3>
                <v-text-field
                  v-model="rutSupervisor"
                  label="Rut Supervisor"
                  counter="10"
                  maxlength="10"
                  :box="isDisabledCap"
                  :readonly="isDisabledCap"
                  @input="dvRutSupervisor()"
                  @focusout="checkRut"
                  @blur="tipeView == 'crear' ? $v.rut.$touch() : null"
                ></v-text-field>
              </v-flex>
              <v-flex md1>
                <v-btn
                  class="check"
                  flat
                  icon
                  color="blue"
                  title="Verificar Rut"
                  @click="loadDataSupervisores()"
                >
                  <v-icon>check_circle</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  v-model="nombreSupervisor"
                  label="Nombre Supervisor"
                  :box="isDisabledCap"
                  :readonly="isDisabledCap"
                  @input="$v.apellido1.$touch()"
                  @blur="tipeView == 'crear' ? $v.apellido1.$touch() : null"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  v-model="apellidoSupervisor"
                  label=" Apellido Supervisor"
                  :box="isDisabledCap"
                  :readonly="isDisabledCap"
                  @input="$v.apellido1.$touch()"
                  @blur="tipeView == 'crear' ? $v.apellido1.$touch() : null"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-container>
    <v-toolbar
      v-if="
        tipeView == 'modificaVisita' || tipeView == 'consultaRealizada'
          ? true
          : false
      "
      color="white"
      dark
      flat
      dense
      cad
    >
      <v-toolbar-title class="indigo--text"
        >Resultado de la visita
      </v-toolbar-title>
    </v-toolbar>
    <v-container>
      <v-layout>
        <v-flex xs12 md6>
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-if="
                  tipeView == 'modificaVisita' ||
                  tipeView == 'consultaRealizada'
                    ? true
                    : false
                "
                v-model="fecha_real"
                :error-messages="fechaRealErrors"
                label="Fecha Resultado"
                :box="isDisabledSel"
                :readonly="isDisabledSel"
                prepend-icon="event"
                v-on="on"
                @input="$v.fecha_real.$touch()"
                @blur="
                  tipeView == 'modificaVisita' ? $v.fecha_real.$touch() : null
                "
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fecha_real"
              @input="menu2 = false"
              no-title
              locale="es"
              first-day-of-week="1"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs8 md6>
          <v-text-field
            v-if="tipeView == 'consultaRealizada' ? true : false"
            v-model="resultadoValue"
            label="Resultado"
            :box="isDisabledSel"
            :readonly="isDisabledSel"
          ></v-text-field>
          <v-select
            v-if="tipeView == 'modificaVisita' ? true : false"
            :items="items"
            v-model="select"
            label="Select"
            single-line
            item-text="nombre"
            item-value="src"
            return-object
            persistent-hint
            :box="isDisabledSel"
            :readonly="isDisabledSel"
            v-on:change="changeRoute(`${select.src}`)"
          ></v-select>
        </v-flex>
      </v-layout>
    </v-container>
    <br />
    <v-card v-if="cardPrevHidden != true || tipeView == 'consultaRealizada'">
      <v-container>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text"
            >Datos de la Ejecución de la visita previa</v-toolbar-title
          >
        </v-toolbar>
        <v-layout>
          <v-flex xs12>
            <v-layout wrap justify-space-around>
              <v-layout>
                <v-flex xs12 md12>
                  <p>Casos Especiales:</p>
                </v-flex>
              </v-layout>
              <v-checkbox
                v-if="ha1Hidden != false"
                v-model="hallazgo1"
                :box="isDisabledselect"
                :readonly="isDisabledselect"
                class="mx-2"
                label="Niños Trans"
              >
              </v-checkbox>
              <v-checkbox
                v-if="ha2Hidden != false"
                v-model="hallazgo2"
                :box="isDisabledselect"
                :readonly="isDisabledselect"
                class="mx-2"
                label="Examinador DS"
              >
              </v-checkbox>
              <v-checkbox
                v-if="ha3Hidden != false"
                v-model="hallazgo3"
                :box="isDisabledselect"
                :readonly="isDisabledselect"
                class="mx-2"
                label="Cambio de Fecha"
              >
              </v-checkbox>
              <v-checkbox
                v-if="ha4Hidden != false"
                v-model="hallazgo4"
                :box="isDisabledselect"
                :readonly="isDisabledselect"
                class="mx-2"
                label="Inicio tarde de la aplicación"
              >
              </v-checkbox>
              <v-checkbox
                v-if="ha5Hidden != false"
                v-model="hallazgo5"
                class="mx-2"
                :box="isDisabledselect"
                :readonly="isDisabledselect"
                label="Curso sin matrícula"
              >
              </v-checkbox>
              <v-checkbox
                v-if="ha6Hidden != false"
                :box="isDisabledselect"
                :readonly="isDisabledselect"
                v-model="hallazgo6"
                class="mx-2"
                label="Otro"
              >
              </v-checkbox>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 md6>
            <v-textarea
              v-if="tipeView != 'consulta'"
              v-model="observacionEspecial"
              label="Observaciones casos especiales"
              :box="isDisabledSel"
              :readonly="isDisabledSel"
            ></v-textarea>
          </v-flex>
        </v-layout>
        <v-card>
          <v-container>
            <v-layout>
              <v-flex
                xs12
                md6
                v-if="tipeView == 'modificaVisita' ? true : false"
              >
                <v-toolbar-title class="indigo--text">
                  Lista Cursos
                </v-toolbar-title>
                <data-adjunto :tipeView="tipeView" :tipeArchive="tipeArchive">
                </data-adjunto>
              </v-flex>
              <v-flex md6>
                <v-text-field
                  v-if="tipeView == 'consultaRealizada' ? true : false"
                  v-model="filenameValue"
                  label="Documento"
                  :box="isDisabledSel"
                  :readonly="isDisabledSel"
                ></v-text-field>
              </v-flex>
              <v-flex md6>
                <v-btn
                  v-if="tipeView == 'consultaRealizada' ? true : false"
                  color="primary"
                  dark
                  class="mb-2"
                  @click="downloadFile()"
                >
                  Descargar
                  <v-icon right dark>cloud_download</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-container>
    </v-card>
    <br />
    <v-card v-if="cardHidden != true || tipeView == 'consultaRealizada'">
      <v-container>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text"
            >Datos de Visita No Efectuada</v-toolbar-title
          >
        </v-toolbar>
        <v-layout>
          <v-flex xs12 md6>
            <v-select
              v-model="motivosValue"
              :items="motivosSelect"
              label="Categorias No aplicación visita"
              item-text="nombre"
              item-value="code"
              :box="isDisabledSel"
              :readonly="isDisabledSel"
              data-vv-name="listaRelatores"
            ></v-select>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 md6>
            <v-textarea
              v-if="tipeView != 'consulta'"
              v-model="observacionVisitaPrev"
              label="Observaciones visita previa"
              :box="isDisabledSel"
              :readonly="isDisabledSel"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <v-dialog v-model="dialogLoading" persistent max-width="390">
      <loading-descarga></loading-descarga>
    </v-dialog>
    <v-card-actions class="pb-3">
      <v-btn
        v-if="tipeView == 'modifica' || tipeView == 'modificaVisita'"
        color="primary"
        dark
        class="mb-2"
        @click="save()"
      >
        Guardar
        <v-icon right dark>save</v-icon>
      </v-btn>
      <v-btn
        v-if="tipeView == 'crear'"
        color="primary"
        dark
        class="mb-2"
        @click="save()"
      >
        Guardar
        <v-icon right dark>save</v-icon>
      </v-btn>

      <v-flex>
        <v-btn
          v-if="btnHidden != true"
          color="primary"
          @click="descargaMasiva()"
          >Descarga masiva</v-btn
        >
      </v-flex>
    </v-card-actions>
  </v-form>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import { misMixins } from "@/mixins/myMixing.js";
import axios from "axios";
import { error } from "util";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";
import DataAdjunto from "@/components/AdjuntoData.vue";

export default {
  name: "visitas-data",
  components: {
    DataAdjunto,
    LoadingDescarga,
  },
  mixins: [misMixins, validationMixin],
  props: {
    tipeView: "",
    id: "",
  },
  data() {
    return {
      select: { nombre: "Sin asignar" },
      items: [
        { nombre: "Sin asignar", src: "/rep0" },
        { nombre: "Efectuada", src: "/rep1" },
        { nombre: "No Efectuada", src: "/rep2" },
      ],
      btnHidden: true,
      cardHidden: true,
      cardPrevHidden: true,
      ha1Hidden: true,
      ha2Hidden: true,
      ha3Hidden: true,
      ha4Hidden: true,
      ha5Hidden: true,
      ha6Hidden: true,
      textHidden: true,
      menu1: false,
      menu2: false,
      dialogLoading: false,
      dialogGrid: false,
      filter: false,
      selectRol: false,
      itemsDocs: [],
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      asuntoDocumento: "",
      fecha_real: "",
      fecha_coordinacion: "",
      allowSpaces: false,
      codigo: "",
      contratoId: "",
      user: "",
      username: "",
      rbd: "",
      nivelesSelect: [],
      nombreRbd: "",
      rbdEmergente: "",
      curso: "",
      nivel: "",
      idVisitas: "",
      centrosSelect: [],
      centrosValue: "",
      validacion: "",
      dv: "",
      regionValue: "",
      comunaValue: "",
      regionesSelect: [],
      comunasSelect: [],
      estadoValue: "",
      estadoSelect: [],
      cumpleFechaValue: "",
      cumpleFechaSelect: [],
      resultadoValue: "",
      select: "",
      resultadoSelect: [],
      rbdEmergente: "",
      letra: "",
      rutExaminador: "",
      dvExaminador: "",
      rutSupervisor: "",
      dvSupervisor: "",
      nombreExaminador: "",
      nombreSupervisor: "",
      apellidoExaminador: "",
      apellidoSupervisor: "",
      rolesValue: "",
      rolesSelect: [],
      motivosValue: "",
      motivosSelect: [],
      observacionVisitaPrev: "",
      observacionEspecial: "",
      hallazgo1: "",
      hallazgo2: "",
      hallazgo3: "",
      hallazgo4: "",
      hallazgo5: "",
      hallazgo6: "",
      usuarioLoggedTipe: "",
      proceso: "",
      tab: "",
      tipeArchive: "",
      filenameValue: "",
      filename: "",
      base64Value: "",
      codigo: "",
      visita: "",
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 4000);
    },
  },

  validations: {
    fecha_real: { required },
    fecha_coordinacion: { required },
  },

  created() {
    this.tipeArchive = "*";

    this.user = this.$store.getters.userLogged.tipo;
    if (this.tipeView === undefined) {
      this.tipeView = this.$route.params.tipeView;
    }
    if (this.tipeView == "modifica") {
      this.loadData();
    }
    if (this.tipeView == "consultaPrevista") {
      this.loadData();
      this.loadDataVisitaPrev();
    }
    if (
      this.tipeView == "modificaVisita" ||
      this.tipeView == "consultaRealizada"
    ) {
      //this.loadData();
      this.loadDataVisitaPrev();
    }
    //this.visita = this.loadData();
    this.id = this.$route.params.id;
    console.log(this.id);

    this.base64Value = this.$store.getters.base64Stored;
    this.filenameValue = this.$store.getters.filenameStored;
    let filename = this.filenameValue;
  },
  mounted() {
    this.tab = this.$store.getters.subTabSelectedStored;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.contratoId = this.$store.getters.contratoStored;
    this.idUsuario = this.$store.getters.userLogged.id;
    this.proceso = this.$store.getters.subProTabSelectedStored;
  },
  computed: {
    fechaErrors() {
      const errors = [];
      if (!this.$v.fecha_coordinacion.$dirty) return errors;
      !this.$v.fecha_coordinacion.required &&
        errors.push("Fecha es obligatorio.");
      return errors;
    },
    fechaRealErrors() {
      const errors = [];
      if (!this.$v.fecha_real.$dirty) return errors;
      !this.$v.fecha_real.required && errors.push("Fecha es obligatorio.");
      return errors;
    },
    isDisabled() {
      if (
        this.tipeView == "modifica" ||
        this.tipeView == "modificaVisita" ||
        this.tipeView == "consultaPrevista" ||
        this.tipeView == "consultaRealizada"
      ) {
        return true;
      }
    },
    isDisabledCap() {
      if (
        this.tipeView == "consultaPrevista" ||
        this.tipeView == "consultaRealizada" ||
        this.tipeView == "modificaVisita"
      ) {
        return true;
      }
    },
    isDisabledSel() {
      if (
        this.tipeView == "modifica" ||
        this.tipeView == "consultaRealizada" ||
        this.tipeView == "consultaPrevista"
      ) {
        return true;
      }
    },

    isDisabledselect() {
      if (this.tipeView == "consultaRealizada") {
        return true;
      }
    },
  },
  methods: {
    changeRoute(a) {
      //
      if (a == "/rep1") {
        this.cardPrevHidden = false;
        this.cardHidden = true;
      } else if (a == "/rep2") {
        this.cardHidden = false;
        this.cardPrevHidden = true;
      } else {
        this.cardHidden = true;
        this.cardPrevHidden = true;
      }
    },

    getRegionName(regionId) {
      let encontrar = this.genRegionComuna.find(function (x) {
        return x.id == regionId;
      });
      return encontrar.nombre;
    },
    getComunaName(comunaId) {
      let encontrar = this.comunasSelect.find(function (x) {
        return x.code == comunaId;
      });
      return encontrar.nombre;
    },
    dvRut() {
      let f = this.formateaRut(this.rutExaminador);
      if (f == undefined) {
        this.rutExaminador = this.rut;
      } else {
        this.rutExaminador = f;
      }
    },
    dvRutSupervisor() {
      let f = this.formateaRut(this.rutSupervisor);
      if (f == undefined) {
        this.rutSupervisor = this.rut;
      } else {
        this.rutSupervisor = f;
      }
    },
    checkRut() {
      let v = this.validaRut(this.rut);

      if (v === false) {
        return console.log("false");
      } else {
        //esto es para hacer algun tipo de validacion
        this.dvExaminador = obtenerDv(this.rutExaminador);
        this.dvSupervisor = obtenerDv(this.rutSupervisor);
        return console.log("verdadero");
      }
    },
    submit() {
      this.$v.$touch();
    },

    async loadData() {
      this.id = this.$route.params.id;
      this.visita = await this.loadVisitas();
      this.rbd = this.visita.rbd;
      this.nombreRbd = this.visita.nombreRbd;
      this.rbdEmergente = this.visita.rbdEmergente;
      this.curso = this.visita.curso;
      this.nivel = this.visita.nivel;
      this.letra = this.visita.letra;
      this.idSalCurso = this.visita.salCursoId;
      this.idVisitaPrev = this.visita.vistaPreviaId;
      this.fecha_coordinacion = this.visita.fecha_visitaPrev;
    },

    async loadVisitas() {
      let idContrato = this.$store.getters.contratoStored;
      let idVisitas = this.id;

      return await axios
        .get("/visitaAplicacion/" + idVisitas + "/" + idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    async downloadFile() {
      this.dialogLoading = true;
      let idContrato = this.$store.getters.contratoStored;
      let idVisitas = this.id;
      let filename = this.filenameValue;
      return await axios
        .get(
          "visitaAplicacion/downloadVisitaPrev/" + idVisitas + "/" + idContrato,
          { responseType: "blob" }
        )
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async loadDataExaminadores() {
      this.id = this.$route.params.id;
      this.examinadores = await this.loadExaminador();
      this.nombreExaminador = this.examinadores.nombre;
      this.apellidoExaminador = this.examinadores.apellido;
    },
    async loadDataRBD() {
      this.id = this.$route.params.id;
      this.cursoInfo = await this.loadCurso();
    },
    async loadCurso() {
      let idContrato = this.$store.getters.contratoStored;
      let idCurso = this.curso;
      this.body = {
        idContrato: idContrato,
        id: idCurso,
      };
      return await axios
        .post("/visitaAplicacion/infoCentro", this.body)
        .then((response) => {
          let cursosNiveles = [];
          response.data.forEach((r) => {
            cursosNiveles.push({ code: r.id, name: r.nivel + " " + r.letra });
            this.nombreCentro = r.nombreStab;
            return [];
          });
          this.nivelesSelect = cursosNiveles;
        })
        .catch(function (error) {
          console.log(error);
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          return [];
        });
    },
    async loadExaminador() {
      let idContrato = this.$store.getters.contratoStored;
      let dvExaminador = this.obtenerDv(this.rutExaminador);
      let rutExaminador = this.obtenerSoloRut(this.rutExaminador);
      this.body = {
        idContrato: idContrato,
        rutExaminador: rutExaminador,
        dvExaminador: dvExaminador,
      };
      return await axios
        .post("/visitaAplicacion/RutVisitaPrev", this.body)
        .then((response) => {
          return response.data;
          console.log(response.data);
        })
        .catch(function (error) {
          console.log(error);
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          return [];
        });
    },

    async loadDataSupervisores() {
      this.id = this.$route.params.id;
      this.supervisores = await this.loadSupervisor();
      this.nombreSupervisor = this.supervisores.nombre;
      this.apellidoSupervisor = this.supervisores.apellido;
    },

    async loadSupervisor() {
      let idContrato = this.$store.getters.contratoStored;
      let dvSupervisor = this.obtenerDv(this.rutSupervisor);
      let rutSupervisor = this.obtenerSoloRut(this.rutSupervisor);
      this.body = {
        idContrato: idContrato,
        rutExaminador: this.rutExaminador,
        dvExaminador: this.dvExaminador,
        rutSupervisor: rutSupervisor,
        dvSupervisor: dvSupervisor,
      };
      return await axios
        .post("/visitaAplicacion/RutVisitaPrev", this.body)
        .then((response) => {
          return response.data;
          console.log(response.data);
        })
        .catch(function (error) {
          console.log(error);
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          return [];
        });
    },
    loadResultadoSelect() {
      //let resultado_vp = this.dataVisitaPrev!=null ? this.dataVisitaPrev.fl_resultado :''
      if (this.tipeView == "modificaVisita") {
        this.resultadoSelect = ["Efectuada", "No Efectuada"];
      } else {
        // this.resultadoValue = resultado_vp
      }
    },
    loadCumpleSelect() {
      //let forma_cap = this.documento.forma_cap!=null ? this.documento.forma_cap :''
      if (this.tipeView == "modificaVisita") {
        this.cumpleFechaSelect = ["Si", "No"];
        //this.cumpleFechaValue = forma_cap
      }
    },
    back() {
      setTimeout(() => {
        this.$router.push({
          name: "ProcesoAplicacion",
        });
      }, 1000);
    },
    save() {
      if (this.tipeView == "crear") {
        this.saveAgendar();
      } else if (this.tipeView == "modificaVisita") {
        this.saveRegistrarVisita();
        // } else {
        //    this.editCapacitacion();
      }
    },
    fechaAnterior() {
      let fechaHoy = new Date();
      let fechaAyer = fechaHoy.setDate(fechaHoy.getDate() - 1);
      let formatoAyer = new Date(fechaAyer).toISOString().substr(0, 10);
      this.fecha_coordinacion = formatoAyer;
    },
    fechaAnterior() {
      let fechaHoy = new Date();
      let fechaAyer = fechaHoy.setDate(fechaHoy.getDate() - 1);
      let formatoAyer = new Date(fechaAyer).toISOString().substr(0, 10);
      this.fecha_real = formatoAyer;
    },
    async loadDataVisitaPrev() {
      this.dataVisitaPrev = await this.loadVisitaPrev();
      this.nombreExaminador = this.dataVisitaPrev.nombreExaminador;
      this.nombreSupervisor = this.dataVisitaPrev.nombreSupervisor;
      this.rutSupervisor = this.dataVisitaPrev.rutSupervisor;
      this.rutExaminador = this.dataVisitaPrev.rutExaminador;
      this.fecha_real = this.dataVisitaPrev.fechaVista_real;
      this.observacionVisitaPrev = this.dataVisitaPrev.obsNoAsistencia;
      this.observacionEspecial = this.dataVisitaPrev.observacionHallazgo;

      this.filenameValue = this.dataVisitaPrev.filename;

      this.rbd = this.dataVisitaPrev.salCursoId.rbd;
      this.nombreRbd = this.dataVisitaPrev.salCursoId.nombreRbd;
      this.rbdEmergente = this.dataVisitaPrev.salCursoId.rbdEmergente;
      this.curso = this.dataVisitaPrev.salCursoId.curso;
      this.nivel = this.dataVisitaPrev.salCursoId.nivel;
      this.letra = this.dataVisitaPrev.salCursoId.letra;
      this.idSalCurso = this.dataVisitaPrev.salCursoId.id;
      //this.idVisitaPrev = this.dataVisitaPrev.id;
      this.fecha_coordinacion = this.dataVisitaPrev.fechaVista_prev;
      //this.resultadoValue = this.dataVisitaPrev.fl_resultado;
      if (this.dataVisitaPrev.fl_resultado == "true") {
        this.resultadoValue = "Efectuada";
      } else {
        this.resultadoValue = "No Efectuada";
      }

      if (this.tipeView == "consultaRealizada") {
        if (this.dataVisitaPrev.hallazgo1 == "true") {
          this.ha1Hidden = true;
        } else {
          this.ha1Hidden = false;
        }
        if (this.dataVisitaPrev.hallazgo2 == "true") {
          this.ha2Hidden = true;
        } else {
          this.ha2Hidden = false;
        }
        if (this.dataVisitaPrev.hallazgo3 == "true") {
          this.ha3Hidden = true;
        } else {
          this.ha3Hidden = false;
        }
        if (this.dataVisitaPrev.hallazgo4 == "true") {
          this.ha4Hidden = true;
        } else {
          this.ha4Hidden = false;
        }
        if (this.dataVisitaPrev.hallazgo5 == "true") {
          this.ha5Hidden = true;
        } else {
          this.ha5Hidden = false;
        }
        if (this.dataVisitaPrev.hallazgo6 == "true") {
          this.ha6Hidden = true;
        } else {
          this.ha6Hidden = false;
        }
      }
      //this.loadResultadoSelect();
      this.loadCumpleSelect();
      this.loadDataMotivos();
    },

    loadMotivos() {
      let idContrato = this.$store.getters.contratoStored;
      return axios
        .get("visitaAplicacion/getAllVisitaNoAsis/" + idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },

    async loadDataMotivos() {
      let motivoCode =
        this.dataVisitaPrev.visitaPrevNoAsistidaId !== undefined &&
        this.dataVisitaPrev.visitaPrevNoAsistidaId != null
          ? this.dataVisitaPrev.visitaPrevNoAsistidaId.id
          : "";
      let motivoVisita =
        this.dataVisitaPrev.visitaPrevNoAsistidaId != null
          ? this.dataVisitaPrev.visitaPrevNoAsistidaId.descripcion
          : "";
      this.dataMotivos = await this.loadMotivos();
      let motivo = [];
      this.dataMotivos.forEach(function (t) {
        motivo.push({
          nombre: t.descripcion,
          code: t.id,
        });
      });
      this.motivosSelect = motivo;
      this.motivosValue = motivoCode;
      return;
    },
    async loadVisitaPrev() {
      let idContrato = this.$store.getters.contratoStored;
      let idVisitas = this.id;

      return await axios
        .get("/visitaAplicacion/visitaPreviaId/" + idVisitas + "/" + idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            //window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    saveAgendar() {
      let idContrato = this.$store.getters.contratoStored;
      let dvExaminador = this.obtenerDv(this.rutExaminador);
      let rutExaminador = this.obtenerSoloRut(this.rutExaminador);
      let rutCompletoExa =
        this.obtenerSoloRut(this.rutExaminador) +
        this.obtenerDv(this.rutExaminador);
      let dvSupervisor = this.obtenerDv(this.rutSupervisor);
      let rutSupervisor = this.obtenerSoloRut(this.rutSupervisor);
      let rutCompletoSup =
        this.obtenerSoloRut(this.rutSupervisor) +
        this.obtenerDv(this.rutSupervisor);

      this.body = {
        idContrato: idContrato,
        fecha_visita_prev: this.formatoFecha(this.fecha_coordinacion),
        salCursoId: this.nivel,
        rutExaminador: rutCompletoExa,
        rutSupervisor: rutCompletoSup,
      };
      axios
        .post("visitaAplicacion/SaveAgendarVistitaPrev", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.back();
        })
        .catch((error) => {
          if (error == undefined || error == null) {
            console.log(error.response.data.defaultMessage);
          } else if (error.response.status == 400) {
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          } else if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION_BACK");
          }
        });
    },
    saveRegistrarVisita() {
      let idContrato = this.$store.getters.contratoStored;
      let base64EncodedStr = this.base64Value;
      let idVisitas = this.id;

      this.body = {
        idContrato: idContrato,
        vistaPreviaId: idVisitas,
        fecha_visita_real: this.formatoFecha(this.fecha_real),
        resultado_vp: this.select.nombre,
        hallazgo1: this.hallazgo1,
        hallazgo2: this.hallazgo2,
        hallazgo3: this.hallazgo3,
        hallazgo4: this.hallazgo4,
        hallazgo5: this.hallazgo5,
        hallazgo6: this.hallazgo6,
        filename: this.filenameValue,
        documento: base64EncodedStr,
        obsCaso_especial: this.observacionEspecial,
        visitaPrevNoAsistidaId: this.motivosValue,
        obsNoAsistencia_vp: this.observacionVisitaPrev,
      };
      axios
        .put("visitaAplicacion/SaveRegistrarVistitaPrev", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.back();
        })
        .catch((error) => {
          if (error == undefined || error == null) {
            console.log(error.response.data.defaultMessage);
          } else if (error.response.status == 400) {
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          } else if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION_BACK");
          }
        });
    },
  },
};
</script>
